import { Component, OnInit, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from 'ngx-toastr';
import { Router } from "@angular/router";
import { first } from 'rxjs/operators';
import { NavbarService } from '../services/navbar.service';
import { AuthenticationService } from '../services/authentication.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-chipsets',
  templateUrl: './chipsets.component.html',
  styleUrls: ['./chipsets.component.scss']
})
export class ChipsetsComponent implements OnInit {
  addProductCat: FormGroup;
  submitted: boolean = false;
  usersubmitted: boolean = false;
  loginsubmitted: boolean = false;
  invalidLogin: boolean = false;
  param2;
  data: any = [];
  modalRef: BsModalRef;
  loading: boolean = false;
  response;
  p: number = 1;
  total: number;
  dateFormat;
  showLoader: boolean = true;
  search: string = "";
  singleChipset: any;
  @ViewChild('myDiv3') myDiv3: ElementRef;
  constructor(private formBuilder: FormBuilder, private modalService: BsModalService, private toastr: ToastrService, public nav: NavbarService, private authenticationService: AuthenticationService, private router: Router) { }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static', keyboard: false });
  }
  get r() { return this.addProductCat.controls; }

  ngOnInit() {

    this.param2 = localStorage.getItem("currentUser");
    this.dateFormat = localStorage.getItem("date_time_format");
    this.dateFormat = this.dateFormat.replace(/^"(.*)"$/, '$1');

    if (this.param2 == null) {
      console.log('in null');
      this.router.navigate(['/login']);
    } else {
      this.nav.show();
    }

    this.addProductCat = this.formBuilder.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      image_url: ['', Validators.required],
    });
    this.getChipsetlist(1);
  }
  getChipsetlist(page: number) {
    this.showLoader = true;
    this.authenticationService.getChipsetlist().subscribe(
      response => {
        this.showLoader = false;
        //if (response['status'] == 200) { 
        if (response['chipList'] !== {}) {
          this.data = response['chipList'].data;
          this.total = response['chipList'].total;
          this.response = response['chipList'];
          this.p = page;
          console.log(this.data);

        }
        //}
      }, error => {
        setTimeout(() => this.toastr.error(error.error.message))
        console.log(error);
        if (error.error.message == "Unauthenticated") {
          localStorage.clear();
          this.authenticationService.loggedOut();
          this.router.navigate(['/login']);
        }
      });
  }

  showChipset(id) {
    let getData = this.data.filter(data => data.id == id);
    this.singleChipset = getData[0];
    let el3: HTMLElement = this.myDiv3.nativeElement as HTMLElement;
    el3.click();
    console.log('vince', this.singleChipset);
  }
  deleteChipset(id) {
    if (confirm("Are you sure you want to Chipsett")) {
      this.authenticationService.deleteChipset(id).subscribe(
        response => {
          //this.getUsers();
          if (response['status'] == 200) {
            console.log('success');
            this.getChipsetlist(1);
            setTimeout(() => this.toastr.success('Chipset deleted successfully!'))
          }
        }, error => {
          console.log('errorrrrr');

          setTimeout(() => this.toastr.error(error.error.message))
        });
    }
  }
  logout() {
    console.log('inlogout');
    this.nav.hide();
    this.authenticationService.logout();
  }

  addCat() {
    this.submitted = true;
    if (this.addProductCat.invalid) {
      return false;
    }
    var data = this.addProductCat.value;
    //return false;
    var myPostObject = {
      name: data.name,
      description: data.description,
      image_url: data.image_url,
    }
    this.authenticationService.addCategory(myPostObject)
      .pipe(first())
      .subscribe(
        data => {
          //console.log(data);
          //this.saveNotification.reset
          setTimeout(() => this.toastr.success('Category added successfully!'))
          this.addProductCat.reset();
          this.submitted = false;
          this.modalRef.hide()
          this.getChipsetlist(1);
          //this.router.navigate(['/admin/chipsets']);

        },
        error => {
          setTimeout(() => this.toastr.error('Something went wrong!'))
          //   this.error = error;
          //   this.loading = false;
        });
  }
  Edituser(id) {
    this.router.navigate(['admin/adduser'], { queryParams: { user_id: id } });
  }

  getPage(page: number) {
    this.loading = true;
    let url = this.response.first_page_url.split("page=");
    url = url[0] + "&page=" + page;
    this.authenticationService.getalluserspagination(url).subscribe(
      response => {
        if (response['chipList'] !== {}) {
          this.data = response['chipList'].data;
          this.total = response['chipList'].total;
          this.p = page;
          console.log(this.data);

        }
      }, error => {
        console.log(error);
      });
  }
  updateFilter() {
    if (this.search.trim() == "") {
      this.getChipsetlist(1);

    } else {
      this.showLoader = true;
      this.data = [];
      this.total = 0;
      this.p = 0;
      let api = "searchchipset";
      this.authenticationService.searchByQueryString(api, this.search).subscribe(
        response => {
          this.showLoader = false;
          if (response['chipList'] !== {}) {
            this.data = response['chipList'].data;
            this.total = response['chipList'].total;
            this.response = response['chipList'];
            this.p = 0;

          }
        }, error => {
          console.log(error);
        });
    }
  }
}
